<template>

</template>

<script>
export default {
  name: 'Qr',

  mounted() {
    this.$gtag.event('qr');
    this.$bricodes.postQr();
    this.$router.push('/home');
  },
};
</script>
